import React, { ReactNode } from "react";

export const ReportContainerLeft = ({
  children,
}: {
  children: ReactNode;
}): JSX.Element => (
  <div style={{ paddingRight: 8, height: "80vh" }}>{children}</div>
);
